import type { UserMe } from '../models/user';

export const checkIsManager = (userMe?: UserMe) =>
  userMe?.role
    ? userMe.role.name.toLowerCase().indexOf('менеджер') > -1
    : false;
